import React from 'react';
import { MessageSquare } from 'lucide-react';

const WHATSAPP_NUMBER = '32475825089';

const WhatsAppButton = ({ language }) => {
  const whatsappTexts = {
    fr: 'Contactez-nous par WhatsApp',
    en: 'Contact us on WhatsApp',
    nl: 'Contacteer ons via WhatsApp'
  };
  
  const buttonText = whatsappTexts[language] || whatsappTexts.en;
  
  return (
    <a
      href={`https://wa.me/${WHATSAPP_NUMBER}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-24 right-6 z-[9999] flex items-center gap-3 px-5 py-4 bg-[#25D366] text-white rounded-full shadow-lg hover:bg-[#20BA5A] transition-all duration-300 hover:scale-105 group"
      aria-label={buttonText}
    >
      <MessageSquare className="w-6 h-6" fill="currentColor" />
      <span className="font-semibold text-sm whitespace-nowrap">
        {buttonText}
      </span>
    </a>
  );
};

export default WhatsAppButton;